<template>
  <div v-if="is_loading" class="loading_com">报告数据加载中...</div>
  <!--  <div class="view_header">
    <TopBar v-if="raw_data && !is_loading" :data="raw_data"></TopBar>
  </div> -->
  <div class="Wrap">
    <!-- v-if="process_form" -->
    <div style="position: relative" v-if="false">
      <div class="down_btn_box" v-if="raw_data.is_report_generation">
        <el-popover placement="bottom" width="200" trigger="click">
          <div>
            <el-form class="custom_form" label-position="top" label-width="80px">
              <el-form-item label="报告类型">
                <el-select v-model="category_name" placeholder="请选择" size="small" clearable filterable
                  @change="resetHandle" style="width: 200px">
                  <el-option v-for="item in raw_data.report_tree.category" :key="item.name" :value="item.name"
                    :label="item.title">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <template #reference>
            <el-button size="small" type="primary">报告配置</el-button>
          </template>
        </el-popover>
      </div>
      <div class="down_btn_box" style="top: 130px" v-if="raw_data.is_report_generation">
        <el-popover placement="bottom" width="200" trigger="click">
          <div>
            <el-form class="custom_form" label-position="top" label-width="80px">
              <el-form-item label="支持格式">
                <el-select v-model="handle_modes" multiple placeholder="请选择" size="small">
                  <template v-for="e in file_types">
                    <el-option :label="e" :value="e"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="是否需要结果文件">
                <el-switch v-model="is_need_result" active-color="#13ce66" inactive-color="#e5e5e5">
                </el-switch>
              </el-form-item>
            </el-form>
            <div style="text-align: right">
              <el-button @click="generateReportFunc" :loading="is_generate_loading" size="small" title="报告生成">确
                定</el-button>
            </div>
          </div>
          <template #reference>
            <el-button size="small" type="primary">报告生成</el-button>
          </template>
        </el-popover>
      </div>
      <div class="down_btn_box" style="top: 165px">
        <el-popover placement="bottom" width="200" trigger="click">
          <div>
            <el-form class="custom_form" label-position="top" label-width="80px">
              <el-form-item label="下载格式">
                <el-select v-model="handle_mode" clearable placeholder="请选择" size="small">
                  <template v-for="e in file_types">
                    <el-option :label="e" :value="e"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="是否需要结果文件">
                <el-switch v-model="is_need_result" active-color="#13ce66" inactive-color="#e5e5e5">
                </el-switch>
              </el-form-item>
            </el-form>
            <div style="text-align: right">
              <el-button @click="downloadHandle" :loading="is_download_loading" size="small" title="报告下载">确
                定</el-button>
            </div>
          </div>
          <template #reference>
            <el-button size="small" type="primary">报告下载</el-button>
          </template>
        </el-popover>
      </div>
    </div>
    <!--  <div class="fold">
      <div class="fold_com" :class="is_retract ? 'fold_f' : ''" @click="retractFun">
        <el-icon class="fold_icon">
          <Fold />
        </el-icon>
      </div>
    </div> -->
    <div class="Sidebar" :class="is_retract ? 'Sidebar_f' : ''">
      <TableOfContents v-if="!is_loading && raw_data" :sections="raw_data.report_tree.result"></TableOfContents>
    </div>

    <div class="Main" :class="is_retract ? 'Main_f' : ''">
      <div class="custom_card" style="padding: 44px 46px" v-if="false">

        <div class="content_com">

          <!-- 一键重分析 -->
          <ReanalysisTask v-if="taskStore.is_reanalysis" :rawData="raw_data"></ReanalysisTask>

          <!--   <NewTask v-if="raw_data && !is_loading && !store.task_id" :rawData="raw_data"></NewTask> -->
          <!-- 新任务 存在app_id,没有task_id -->
          <NewTask v-else-if="raw_data && !is_loading && store.app_id && !store.task_id" :rawData="raw_data"></NewTask>

          <!-- 历史任务 -->
          <template v-else-if="!taskStore.is_reanalysis">
            <template v-if="raw_data && task_info">
              <!--  <TaskInfoCom :task_info="task_info"></TaskInfoCom> -->
              <HistoryTask v-if="raw_data && !is_loading" :categoryName="category_name" :raw_data="raw_data"
                :task_info="task_info" @switchConfig="switchConfig" @generateReport="generateReport"
                @downloadHandle="downloadHandleFunc">
              </HistoryTask>
            </template>
            <!-- <div v-if="store.task_id && process_form && raw_data.report_tree.is_show_workflow_input"
              style="margin-top: 60px;">
              <div style="width: 100%; margin: 0 auto">
                <el-collapse>
                  <el-collapse-item title="参数设置" name="1">
                    <template #title="{ isActive }">
                      <div class="custom_collapse_title">
                        <div class="flex">
                          <img src="./components/NewStatus/img/Frame_1.png" alt="">
                          <span class="title_text">分析配置</span>
                        </div>
                        <div class="flex" style="gap: 24px;">
                        </div>
                      </div>
                    </template>
                    <div class="cell_container">
                      <ComplexForms ref="processForm" :filtered_data="process_form"></ComplexForms>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div> -->
            <ContentCom v-if="template_list && !is_loading" :data="template_list" :input_json="raw_data.input_json"
              :output_json="raw_data.output_json" :task_result="task_result">
            </ContentCom>
          </template>
        </div>
      </div>




      <div class="custom_card" style="padding: 44px 46px">

        <div class="content_com">

          <!-- 一键重分析 -->
          <ReanalysisTask v-if="taskStore.is_reanalysis" :rawData="raw_data"></ReanalysisTask>
          <!-- 新任务 -->
          <NewTask v-else-if="raw_data && !is_loading && store.app_id && !store.task_id" :rawData="raw_data"></NewTask>
          <!-- 历史任务 -->
          <div v-show="(taskStore.is_reanalysis==false && store.task_id) || (!store.task_id && !store.app_id)">
            <template v-if="raw_data && task_info">
              <HistoryTask v-if="raw_data && !is_loading" :categoryName="category_name" :raw_data="raw_data"
                :task_info="task_info" @switchConfig="switchConfig" @generateReport="generateReport"
                @downloadHandle="downloadHandleFunc">
              </HistoryTask>
            </template>
            <ContentCom v-if="template_list && !is_loading" :data="template_list" :input_json="raw_data.input_json"
              :output_json="raw_data.output_json" :task_result="task_result">
            </ContentCom>
          </div>
        </div>
      </div>


    </div>

    <el-dialog v-model="is_svgedit_dialog" width="90%" top="15px" :close-on-click-modal="false"
      :before-close="handleClose">
      <div id="svgedit_container" style="width: 100%; height: 700px"></div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="saveSvgEdit">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
  import {
    ref,
    defineProps,
    watch,
    onBeforeMount,
    onMounted,
    onBeforeUpdate,
    onUpdated,
    onBeforeUnmount,
    onUnmounted,
    defineEmits,
  } from "vue";
  import { useStorage } from "@vueuse/core";
  import { useElementPlusTheme } from "use-element-plus-theme";
  import PubSub from "pubsub-js";
  import {
    getQueryParams,
    flattenReportData,
    filterDataByAppnameAndType,
    filterDataInput,
    formatFormData,
    validateArray,
    restoreFormKeys,
    filterDataByAppnameAndTypeAndShow
  } from "@/utils/tool.js";
  import { loadScript } from "@/utils/auth.js";
  import {
    get_template_config,
    get_report_data,
    generate_report,
    write_file_data,
    get_task_list_all,
    get_flow_input_form,
    get_color_group
  } from "@/api/index.js";
  import { ElMessage } from "element-plus";
  import TopBar from "@/components/TopBar/index";
  import TableOfContents from "@/components/TableOfContents/index";
  import TaskInfoCom from "@/components/TaskInfoCom/index";
  import ComplexForms from "@/components/ComplexForms/index";
  import ContentCom from "@/components/ContentCom/index";


  import NewTask from "@/components/NewStatus/NewTask.vue";
  import HistoryTask from "@/components/NewStatus/HistoryTask.vue";
  import ReanalysisTask from "@/components/NewStatus/ReanalysisTask.vue";



  import { useStore } from "@/Store/index.js";
  import { storeToRefs } from 'pinia';
  import { useTaskStore, useFormStore } from "@/Store/task.js";

  const formStore = useFormStore();



  const emit = defineEmits([]);
  const props = defineProps();
  const store = useStore();
  const taskStore = useTaskStore();

  const { is_reanalysis } = storeToRefs(taskStore)

  const is_loading = ref(false); //是否正在加载
  const category_name = ref(null); //分类名称
  const raw_data = ref(null); //原始数据
  const template_list = ref(null); //模板列表
  const process_form = ref(null); //流程表单
  const task_result = ref(null); //任务结果
  const task_info = ref(null); //任务信息

  const handle_mode = ref("html");
  const handle_modes = ref(["html"]);
  const file_types = ref(["html", "docx", "pdf"]);

  const history_data_token = ref(null); //历史数据token
  const node_history = ref({}); //节点历史数据
  const is_need_result = ref(true); //是否需要结果文件
  const is_generate_loading = ref(false); //报告生成loading
  const is_download_loading = ref(false); //报告下载loading

  const is_retract = ref(false); //是否收起

  const save_svg_token = ref(null); //保存svg token
  const is_svgedit_dialog = ref(false); //是否显示svg编辑弹窗
  const current_picture = ref(null); //当前svg图片
  const svgEditor = ref(null); //svg编辑器

  let Editor = null; // svg编辑器实例

  const layoutThemeColor = useStorage("layout-theme-color", "#6c216d"); // 默认主题色
  const { changeTheme } = useElementPlusTheme(layoutThemeColor.value); // 初始化主题色

  const themeColors = [
    { color: "#1b2a47", themeName: "道奇蓝" },
    { color: "#722ed1", themeName: "深紫罗兰色" },
    { color: "#eb2f96", themeName: "深粉色" },
    { color: "#f5222d", themeName: "猩红色" },
    { color: "#fa541c", themeName: "橙红色" },
    { color: "#13c2c2", themeName: "绿宝石" },
    { color: "#52c41a", themeName: "酸橙绿" },
  ];


  function testFunc() {
    console.log(taskStore.is_reanalysis);
    console.log(typeof taskStore.is_reanalysis);
  };



  const changeThemeColor = (color) => {
    layoutThemeColor.value = color; // 保存主题色
    changeTheme(color); // 修改 Element Plus 组件主题色
  };

  const initFunc = function () {
    const currentPath = window.location.href; //获取当前地址
    const pathParams = getQueryParams(currentPath);
    if (pathParams.app_id) {
      apiHandle(pathParams);
    } else {
      jsonHandle();
    }
  };

  //获取报告数据
  const getReportData = function (pathParams) {
    const { app_id, task_id } = pathParams;
    const params = {
      app_id: app_id,
      task_id: task_id,
      input_data: {},
      category_name: category_name.value,
    };
    get_report_data(params).then((result) => {
      /*   console.log("获取到的报告数据", typeof result);
        //把结果数据下载为txt文件
        try {
          const textContent =
            typeof result === "object"
              ? JSON.stringify(result, null, 2)
              : String(result);
          const blob = new Blob([textContent], { type: "text/plain;charset=utf-8" });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `report.txt`;
          link.click();
          URL.revokeObjectURL(url);
        } catch (e) {
          console.error("保存报告文件失败：", e);
        } */




      task_result.value = result.data;
      const keyToRemove = "data";
      const { [keyToRemove]: _, ...obj2 } = result; //移除data属性
      task_info.value = obj2;
    }).catch((err) => {

    });
  };

  const apiHandle = function (pathParams) {
    const { app_id, id, ticket } = pathParams;
    store.setAppId(app_id); //保存app_id
    store.setTicket(ticket); //保存ticket

    const task_id = id ? id : "";
    store.setTaskId(task_id); //保存task_id

    const params_s = {
      app_id: app_id,
      task_id: task_id,
      app_type: "dynamic_document",
      category_name: category_name.value,
    };
    is_loading.value = true;
    get_template_config(params_s).then((result) => {
      console.log("模板数据", result);

      taskStore.template_config = result; //保存模板配置


      if (!category_name.value && result.report_tree.p_data && result.report_tree.p_data.name) {
        category_name.value = result.report_tree.p_data.name;
        if (category_name.value) store.setCategoryName(category_name.value);
      }
      // 默认选择第一个报告类型
      else if (!category_name.value && result.is_report_generation && result.report_tree.category.length > 0) {
        category_name.value = result.report_tree.category[0].name || null;
        if (category_name.value) store.setCategoryName(category_name.value);
        initFunc();
        return;
      }
      raw_data.value = result; //原始数据

      console.log("raw_data是什么", raw_data.value);

      template_list.value = flattenReportData(result.report_tree.result); //模板列表
      const processForm = filterDataByAppnameAndType(result.input_json);
      process_form.value = processForm;

      const form_list = formatFormData(processForm);
      if (validateArray(form_list)) {
        //流程参数,不论顶部流程表单是否存在,提交时都需要 携带流程参数
        const formValues = form_list.reduce((acc, cur) => {
          acc[cur.key] = cur.default || null;
          return acc;
        }, {});
        const format_process_form = restoreFormKeys(formValues);

        store.setProcessForm(format_process_form); //保存流程参数
      }
      //修改主题色
      if (result.System_conf.theme_color)
        changeThemeColor(result.System_conf.theme_color);
      is_loading.value = false; //加载完成
      if (id) {
        //存在任务id，则请求任务结果
        getReportData({ app_id, task_id });
      }
    }).catch((err) => {
      is_loading.value = false;
    });
  };


  //获取输入表单
  const getInputFormFunc = function (appId, taskId) {
    get_flow_input_form(appId, taskId).then((result) => {
      console.log("获取到的输入表", result);
      //
      const processForm = filterDataByAppnameAndTypeAndShow(result.input_json);
      //全部流程参数
      // const processAllForm = filterDataByAppnameAndType(result.input_json);
      const processAllForm = filterDataInput(result.input_json);

      console.log("新表单接口的数据", processForm);
      taskStore.start_node_name = result.node_name; //保存开始节点名称
      taskStore.current_task_name = result.task_name; //保存当前任务名称
      formStore.setProcessForms(processForm); //保存流程表单
      formStore.setAllProcessForms(processAllForm); //保存流程表单
    }).catch((err) => {
      console.error(err);
    });
  };

  //获取颜色组
  const getColorGroup = () => {
    if (!store.app_id) return;
    get_color_group().then((result) => {
      store.setAllColors(result); //保存颜色组
    }).catch((err) => {
      console.error(err);
    });
  };


  const jsonHandle = function () {
    // 本地模式 加载数据
    is_loading.value = true;
    loadScript("./static/js/report_config_data.js", "report_config_data").then((report_config_data) => {
      raw_data.value = report_config_data; //原始数据
      taskStore.template_config = report_config_data; //保存模板配置
      template_list.value = flattenReportData(report_config_data.report_tree.result); //模板列表
      if (report_config_data.System_conf.theme_color)
        changeThemeColor(report_config_data.System_conf.theme_color); //修改主题色
      loadScript("./static/js/report_result_data.js", "report_result_data").then(
        (report_result_data) => {
          task_result.value = report_result_data.data;
          const keyToRemove = "data";
          const { [keyToRemove]: _, ...obj2 } = report_result_data; //移除data属性
          task_info.value = obj2;
        }
      ); //加载任务结果数据
      is_loading.value = false; //加载完成
    }).catch(() => {
      console.error("加载失败");
    });
  };

  const switchConfig = function (val) {
    // 历史数据切换
    resetHandle(val);
  };

  const resetHandle = function (val) {
    // 报告类型切换
    window.localStorage.clear();
    category_name.value = val;
    store.setCategoryName(val);
    initFunc();
  };

  const generateReport = function (val) {
    //报告生成
    const params = {
      app_id: store.app_id,
      task_id: store.task_id,
      input_data: node_history.value,

      ...val,

      /*  category_name: category_name.value, */
      /* handle_type: "generate", // 处理类型 */
      /*  handle_mode: handle_mode.value, */
      /* is_need_result: is_need_result.value, //是否需要结果文件 */
    };
    is_generate_loading.value = true;
    generate_report(params).then((result) => {
      if (result.status == "200" && result.message) {
        ElMessage.success(result.message || "报告生成成功");
        is_generate_loading.value = false;
      }
    }).catch((err) => {
      console.error(err);
      is_generate_loading.value = false;
    });
  };

  const generateReportFunc = function () {
    //报告生成
    const params = {
      app_id: store.app_id,
      task_id: store.task_id,
      input_data: node_history.value,
      category_name: category_name.value,
      handle_type: "generate", // 处理类型
      handle_mode: handle_mode.value,
      is_need_result: is_need_result.value, //是否需要结果文件
    };
    is_generate_loading.value = true;
    generate_report(params)
      .then((result) => {
        if (result.status == "200" && result.message) {
          ElMessage.success(result.message || "报告生成成功");
          is_generate_loading.value = false;
        }
      })
      .catch((err) => {
        console.error(err);
        is_generate_loading.value = false;
      });
  };

  const downloadHandle = function () {
    //报告下载
    const params = {
      app_id: store.app_id,
      task_id: store.task_id,
      input_data: node_history.value,
      category_name: category_name.value,
      handle_type: "download",
      handle_mode: handle_mode.value,
      is_need_result: is_need_result.value, //是否需要结果文件
    };
    is_download_loading.value = true;
    generate_report(params)
      .then((result) => {
        if (result.status == "200" && result.message) {
          ElMessage.success(result.message);
          is_download_loading.value = false;
        }
      })
      .catch((err) => {
        console.error(err);
        is_download_loading.value = false;
      });
  };

  const downloadHandleFunc = function (val) {
    const params = {
      app_id: store.app_id,
      task_id: store.task_id,
      input_data: node_history.value,

      ...val

      /*  category_name: category_name.value,
       handle_type: "download",
       handle_mode: handle_mode.value,
       is_need_result: is_need_result.value, //是否需要结果文件 */
    };
    is_download_loading.value = true;
    generate_report(params).then((result) => {
      if (result.status == "200" && result.message) {
        ElMessage.success(result.message);
        is_download_loading.value = false;
      }
    }).catch((err) => {
      console.error(err);
      is_download_loading.value = false;
    });
  };

  const retractFun = function () {
    // 折叠
    is_retract.value = !is_retract.value;
  };

  const openSvgEdit = function (svgData) {
    // 打开svg编辑弹窗
    if (window.top === window) {
      //当前页面为顶级页面
      is_svgedit_dialog.value = true;
      setTimeout(() => {
        loadSvgEdit(svgData);
      }, 300);
    } else {
      //有父级页面则 发送消息，否则 svgedit 会加载失败，是同源策略限制
      window.parent.postMessage({ type: "dynamic_document", data: svgData }, "*");
    }
  };

  const loadSvgEdit = function (svgData) {
    // 加载svg编辑器
    //判断是server模式还是本地模式
    const isFile = window.location.protocol === "file:";
    const isHttp =
      window.location.protocol === "http:" || window.location.protocol === "https:";
    if (isFile) {
      // console.log('当前是通过 file:// 打开的（本地文件环境）');
      ElMessage.error("当前环境不支持 SVG 编辑，请在线访问或联系管理员！");
      return false;
    } else if (isHttp) {
      // console.log('当前是通过 http(s):// 访问的（线上或本地 server）');
      const element = document.getElementById("svgedit_container");
      if (element) element.innerHTML = ""; // 清空内容
      svgEditor.value = new Editor(element);
      svgEditor.value.setConfig({
        allowInitialUserOverride: true,
        noDefaultExtensions: true,
        extensions: [],
        userExtensions: [],
        lang: "zh-CN",
      });
      svgEditor.value.init().then(() => {
        svgEditor.value.loadFromString(svgData);
      });
    }
  };

  const handleClose = function () {
    // 关闭svg编辑弹窗
    const element = document.getElementById("svgedit_container");
    element.innerHTML = ""; //清空svg编辑器内容
    svgEditor.value = null;
    is_svgedit_dialog.value = false;
  };

  const saveSvgEdit = function () {
    // 保存svg编辑结果

    const updatedSvgData = svgEditor.value.svgCanvas.getSvgString();
    const params = {
      callback_name: "file_path",
      file_path: current_picture.value.path,
      callback_function: {
        type: "svg",
      },
      data: updatedSvgData,
    };

    console.log("保存的参数", params);


    write_file_data(params).then((result) => {
      if (result.code == 200) {
        ElMessage.success("修改成功");
        PubSub.publish(`svg_save_callback_${current_picture.value.title}`, current_picture.value);
        handleClose();
      }
    }).catch((err) => {
      console.error(err);
    });
  };

  const getTaskListAll = function () {
    if (!store.task_id) return;
    get_task_list_all({ task_id: store.task_id }).then((result) => {
      console.log("获取任务数量", result);
      if (result.data) {
        taskStore.setAllTaskData(result.data);
      }
    }).catch((err) => {

    });
  };


  watch(() => props, (newData, oldData) => {

  });


  watch(is_reanalysis, (newVal, oldVal) => {
    console.log('is_reanalysis变化了:', oldVal, '→', newVal)

    // 在这里写你要做的逻辑，比如重新拉取数据、显示弹窗等
    if (newVal === true) {
      // do something...


    }
  })


  onBeforeMount(() => {
    initFunc();
  });
  onMounted(() => {

    getTaskListAll();//获取任务列表
    getColorGroup();//获取颜色组

    if (store.app_id && store.task_id) {
      getInputFormFunc(store.app_id, store.task_id);
    } else if (store.app_id) {
      getInputFormFunc(store.app_id, null);
    }


    if (store.app_id) {
      import("../public/static/js/editor/Editor.js").then((module) => {
        //在线模式才加载SVG编辑器
        console.log("svgedit已加载");
        Editor = module.default;
      }).catch((error) => {
        console.error("加载SVG编辑器失败，请检查网络或联系管理员！");
      });
    }

    if (store.app_id && !store.task_id) {
      is_retract.value = true;
    } else {
      is_retract.value = false;
    }

    history_data_token.value = PubSub.subscribe("history_data", function (msg, data) {
      // 历史数据切换
      node_history.value[data.task_name] = data.id;
    });

    save_svg_token.value = PubSub.subscribe("svg_data", function (msg, data) {
      // 保存svg
      if (data) {
        current_picture.value = data;
        openSvgEdit(data["data"]);
      }
    });

    //有父级页面则 发送接受消息，否则 svgedit 会加载失败，是同源策略限制
    window.addEventListener("message", (event) => {
      const { type, data } = event.data;
      if (type === "dynamic_document") {
        is_svgedit_dialog.value = true;
        setTimeout(() => {
          loadSvgEdit(data);
        }, 300);
      } else {
        return false;
      }
    });
  });
  onBeforeUpdate(() => { });
  onUpdated(() => { });
  onBeforeUnmount(() => {
    if (history_data_token.value) PubSub.unsubscribe(history_data_token.value);
  });
  onUnmounted(() => { });
</script>
<style scoped>
  .loading_com {
    position: fixed;
    top: 100px;
    right: 0;
    z-index: 100;
    padding: 10px;
    background-color: #fff;
  }

  .view_header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: var(--header-height);
    background-color: aliceblue;
    z-index: 300;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }

  .Wrap {
    height: 100%;
    /*  max-width: var(--main-width); */
    /* width: 1660px; */
    width: 86%;
    max-width: 1660px;
    margin: 0 auto;
  }

  .down_btn_box {
    position: absolute;
    right: -70px;
    top: 95px;
  }

  .fold_com {
    width: 50px;
    height: 24px;
    position: fixed;
    margin-left: calc(var(--sidebar-width) - 55px);
    margin-top: 10px;
    border-radius: 30px 0 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    transition: all 0.6s;
    background: #e5e5e5;
    top: var(--header-height);
    z-index: 20;
    word-break: break-word;
  }

  /* .fold_com svg,
  .fold_com img {
    transition: all 0.6s;
  }

  .fold_com img {
    width: 1.2rem;
  } */

  .fold_icon {
    font-size: 20px;
    color: var(--el-color-primary);
  }

  .fold_f {
    margin-left: 0;
    border-radius: 0 25px 25px 0;
  }

  .fold_f img,
  .fold_f .fold_icon {
    transform: rotate(180deg);
  }

  .Sidebar {
    width: var(--sidebar-width);
    position: fixed;
    /*  top: var(--header-height); */
    top: 0;
    bottom: 0;
    z-index: 9;
    overflow-y: auto;
    /* padding: 40px 0 30px; */
    padding: 0 0 30px;
    padding-right: 28px;
    word-break: break-word;
    background-color: transparent;
    max-height: 100vh;
    overflow: hidden;
    box-sizing: border-box;
  }

  .Sidebar_f {
    display: none;
  }

  .Main {
    padding-left: var(--sidebar-width);
    /* padding-top: calc(var(--header-height) + 35px); */
    padding-top: 0;
    padding-bottom: 2rem;
    background: var(--page-background);
    transition: all 0.6s;
    /*  margin-top: 100px; */
  }

  .Main_f {
    padding-left: 0;
  }

  .content_com {
    /* padding: 0 20px 0 80px; */
    padding: 0 20px 0 20px;
    box-sizing: border-box;
  }

  /*   .custom_collapse_title {
    width: calc(100% - 50px);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title_text {
      color: var(--el-color-primary);
      font-size: 18px;
      display: inline-block;
      margin-left: 12px;
    }
  }

  .status_btn {
    font-size: 16px;
    font-weight: 400;
    padding: 0 16px;
    height: 39px;
    border: 1px solid;
    border-radius: 6px;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
  }

  .status_btn1 {
    color: #5cb85c;
    border-color: #5cb85c;
  }

  .status_btn2 {
    color: #3F6CAF;
    border-color: #3F6CAF;
  }

  .status_btn3 {
    color: #AF3F3F;
    border-color: #AF3F3F;
  } */
</style>